import { createContext } from 'react'

export type FormOptionsContext = {
	/** Fields will be instructed to show a changed indicator if they are dirty. */
	readonly showChangedFields: boolean
	/** Fields will be instructed to show the optional hint if not required. */
	readonly showOptionalHint: boolean
}

export const context = createContext<FormOptionsContext | null>(null)
